import api from './authService';

/**
 * Public vendor success stories - no auth required. Used by VendorSuccessStories page.
 */
export const vendorSuccessStoriesService = {
  get: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(`/vendor-success-stories${queryString ? `?${queryString}` : ''}`);
    return response.data;
  },
};
